import { clearStoredTokens } from "../hooks/use-auth-tokens.js";
import { SIXTY_SECONDS, THIRTY_SECONDS, performRefresh } from "../util/tokens.js";
import { useEffect, useState } from "react";

//#region src/client/components/AuthHeartbeat.tsx
const AuthHeartbeat = ({ clientId, expiry, logoutUrl, refreshToken, tokenUrl }) => {
	const [nextCheck, setNextCheck] = useState(-1);
	useEffect(() => {
		if (expiry > Date.now() + SIXTY_SECONDS) {
			const timer = setTimeout(() => {
				setNextCheck(Date.now() + THIRTY_SECONDS);
			}, THIRTY_SECONDS);
			return () => clearTimeout(timer);
		}
		const doRefresh = async () => {
			try {
				await performRefresh(refreshToken, clientId, tokenUrl);
			} catch {
				clearStoredTokens();
				const url = new URL(logoutUrl, window.location.origin);
				url.searchParams.set("refreshError", "true");
				window.location.href = url.toString();
			}
		};
		doRefresh();
	}, [
		clientId,
		expiry,
		logoutUrl,
		nextCheck,
		refreshToken,
		tokenUrl
	]);
	return null;
};

//#endregion
export { AuthHeartbeat };